import {
  GET_RESPONSES,
  GET_RESPONSES_SUCCESS,
  GET_RESPONSE_BY_ID,
  GET_RESPONSE_BY_ID_SUCCESS,
  GET_RESPONSES_BY_TEMPALTE_ID,
  GET_RESPONSES_BY_TEMPALTE_ID_SUCCESS,
  GET_RESPONSE_BY_USER,
  GET_RESPONSE_BY_USER_SUCCESS,
  GET_RESPONSE_BY_BUSINESS,
  GET_RESPONSE_BY_BUSINESS_SUCCESS,
  GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID,
  GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID_SUCCESS,
  GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID,
  GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID_SUCCESS,
  ADD_RESPONSE_TO_SIMPLE_FORM,
  ADD_RESPONSE_TO_SIMPLE_FORM_SUCCESS,
  POST_RESPONSES,
  POST_RESPONSES_SUCCESS,
  SAVE_RESPONSES,
  SAVE_RESPONSES_SUCCESS,
  PATCH_RESPONSES_BY_ID,
  PATCH_RESPONSES_BY_ID_SUCCESS,
  DELETE_RESPONSES_BY_ID,
  DELETE_RESPONSES_BY_ID_SUCCESS,
  POST_FILES_FOR_RESPONSE,
  POST_FILES_FOR_RESPONSE_SUCCESS,
  DELETE_FILE_FOR_RESPONSE,
  RESET_ID_SAVE_RESPONSES,
} from "./constants"

export function getResponsesAction() {
  return {
    type: GET_RESPONSES,
  }
}
// GET
export function getResponsesSuccess(payload) {
  return {
    type: GET_RESPONSES_SUCCESS,
    payload: payload,
  }
}

export function getResponseByIdAction(payload) {
  return {
    type: GET_RESPONSE_BY_ID,
    payload: payload,
  }
}

export function getResponseByIdSuccess(payload) {
  return {
    type: GET_RESPONSE_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function getResponsesByTemplateIdAction(payload) {
  return {
    type: GET_RESPONSES_BY_TEMPALTE_ID,
    payload: payload,
  }
}

export function getResponsesByTemplateIdSuccess(payload) {
  return {
    type: GET_RESPONSES_BY_TEMPALTE_ID_SUCCESS,
    payload: payload,
  }
}

export function getResponsesByUserAction(payload) {
  return {
    type: GET_RESPONSE_BY_USER,
    payload: payload,
  }
}

export function getResponsesByUserSuccess(payload) {
  return {
    type: GET_RESPONSE_BY_USER_SUCCESS,
    payload: payload,
  }
}

export function getResponsesByBusinessAction(payload) {
  return {
    type: GET_RESPONSE_BY_BUSINESS,
    payload: payload,
  }
}

export function getResponsesByBusinessSuccess(payload) {
  return {
    type: GET_RESPONSE_BY_BUSINESS_SUCCESS,
    payload: payload,
  }
}

export function getGlobalResponseInformationByTemplateIdAction(payload) {
  return {
    type: GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID,
    payload: payload,
  }
}

export function getGlobalResponseInformationByTemplateIdSuccess(payload) {
  return {
    type: GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID_SUCCESS,
    payload: payload,
  }
}

export function getGlobalResponseInformationByResponseIdAction(payload) {
  return {
    type: GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID,
    payload: payload,
  }
}

export function getGlobalResponseInformationByResponseIdSuccess(payload) {
  return {
    type: GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID_SUCCESS,
    payload: payload,
  }
}

//Response to simple form
export const addResponseToSimpleFormAction = payload => ({
  type: ADD_RESPONSE_TO_SIMPLE_FORM,
  payload: payload,
})

export const addResponseToSimpleFormSuccess = payload => ({
  type: ADD_RESPONSE_TO_SIMPLE_FORM_SUCCESS,
  payload: payload,
})

export function postResponseAction(payload) {
  return {
    type: POST_RESPONSES,
    payload: payload,
  }
}

export function postResponseSuccess(payload) {
  return {
    type: POST_RESPONSES_SUCCESS,
    payload: payload,
  }
}

export function saveResponseAction(payload) {
  return {
    type: SAVE_RESPONSES,
    payload: payload,
  }
}

export function saveResponseSuccess(payload) {
  return {
    type: SAVE_RESPONSES_SUCCESS,
    payload: payload,
  }
}

export function resetIdResponseSaveAction(payload) {
  return {
    type: RESET_ID_SAVE_RESPONSES,
    payload: payload,
  }
}
// PATCH
export function patchResponseByIdAction(payload) {
  return {
    type: PATCH_RESPONSES_BY_ID,
    payload: payload,
  }
}

export function patchResponseByIdSuccess(payload) {
  return {
    type: PATCH_RESPONSES_BY_ID_SUCCESS,
    payload: payload,
  }
}
// DELETE
export function deleteResponseByIdAction(payload) {
  return {
    type: DELETE_RESPONSES_BY_ID,
    payload: payload,
  }
}

export function deleteResponseByIdSuccess(payload) {
  return {
    type: DELETE_RESPONSES_BY_ID_SUCCESS,
    payload: payload,
  }
}
// FILES
export function postFileForResponseAction(payload) {
  return {
    type: POST_FILES_FOR_RESPONSE,
    payload: payload,
  }
}
export function postFileForResponseSuccessAction(payload) {
  return {
    type: POST_FILES_FOR_RESPONSE_SUCCESS,
    payload: payload,
  }
}

export function deleteFileForResponseAction(payload) {
  return {
    type: DELETE_FILE_FOR_RESPONSE,
    payload: payload,
  }
}
